import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";

const INFO_ROWS = [
    { label: "Business Name", value: "PISI LIMITED" },
    { label: "Business Activity", value: "Wholesale & Retail" },
    { label: "Location", value: "Croydon, United Kingdom" },
];

export const About = () => (
    <section id="about" data-testid="about-section" className="bg-white">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-20 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:py-28">
            <Reveal className="relative order-2 lg:order-1">
                <div
                    className="absolute -bottom-4 -right-4 hidden h-full w-full border border-gold/50 sm:block"
                    aria-hidden="true"
                />
                <img
                    src="/images/about-warehouse.jpg"
                    alt="Storefront of an independent UK retail shop"
                    data-testid="about-image"
                    className="hero-image-frame relative h-[300px] w-full object-cover sm:h-[420px] lg:h-[500px]"
                    loading="lazy"
                />
            </Reveal>

            <div className="order-1 lg:order-2">
                <SectionHeading eyebrow="About Us" title="About PISI LIMITED" />
                <Reveal delay={120}>
                    <p className="mt-6 text-base leading-relaxed text-slate-600">
                        PISI LIMITED is a UK-based wholesale and retail business serving customers
                        with a broad selection of everyday consumer products. Our product offering
                        spans groceries, beverages, household products and other general retail
                        items.
                    </p>
                    <p className="mt-4 text-base leading-relaxed text-slate-600">
                        We aim to make product sourcing straightforward by providing customers and
                        businesses with access to practical everyday goods through a reliable and
                        professional service.
                    </p>
                    <dl
                        data-testid="about-info-panel"
                        className="mt-9 divide-y divide-slate-200 border border-slate-200 bg-slate-50"
                    >
                        {INFO_ROWS.map((row) => (
                            <div
                                key={row.label}
                                className="flex flex-col gap-1 px-6 py-4 sm:flex-row sm:items-center sm:justify-between"
                            >
                                <dt className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
                                    {row.label}
                                </dt>
                                <dd className="font-heading text-sm font-semibold text-navy-900">
                                    {row.value}
                                </dd>
                            </div>
                        ))}
                    </dl>
                </Reveal>
            </div>
        </div>
    </section>
);
